import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ec52702e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/css/mintPage.scss?vue&type=style&index=0&id=ec52702e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec52702e",
  null
  
)

export default component.exports